export default [
	'/',
	'/personal/how/online_shopping',
	'/personal/how/offline_kiosk',
	'/personal/how/qr',
	'/personal/how/jpworldpay_creditcard',
	'/personal/how/trade_and_cashback',
	'/personal/request/send',
	'/personal/request/receive',
	'/personal/request/deposit',
	'/personal/asset/account',
	'/personal/request/commission',
	'/personal/asset/wallet',
	'/personal/asset/jpys',
	'/personal/asset/sale',
	'/personal/asset/exchange',
	'/business/how/start',
	'/business/how/receive',
	'/business/how/pay',
	'/business/how/risk',
	'/business/operation/corps',
	'/business/operation/platform',
	'/business/operation/pay',
	'/business/operation/global',
	'/business/pay',
	'/development',
	'/terms/terms/franchise_agreement',
	'/terms/terms/guideline',
	'/terms/terms/legal_indication',
	'/terms/terms/privacy_policy',
	'/cookies',
	'/development/main',
];
